/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, { useEffect, useState } from 'react';
import { authService } from 'services/auth/AuthService';

export const AuthCallback = () => {
  const [isCompleted, setIsCompleted] = useState(false);
  const nextUrl = localStorage.getItem('next_url') || '/';

  useEffect(() => {
    async function completeAuthentication() {
      setIsCompleted(await authService.completeAuthentication());
    }
    completeAuthentication();
  }, []);
  return isCompleted ? <>{window.location.assign(nextUrl)}</> : null;
};
